import { frontendserverurl } from './../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { SnackService } from './snack.service';
import { serverurl } from '../../environments/environment';
import { CompanyType } from '../lib/interfaces/company';
import { UserRole } from '../lib/interfaces/user';
import { Category } from '../interfaces/categoryInterface';
import { AgentConfig } from '../lib/interfaces/aitypes';
import { StreamClosingType } from '../lib/interfaces/generic-streams';
import { GenericStreamsService } from './generic-streams.service';
import { CustomLoginFormConfig } from '../lib/interfaces/configdata';

interface tag {
    "id": string;
    "tagGroupId": string;
    "name": string;
}
interface tagGroup {
    "id": string,
    "name": string
}
export interface Llm {
    id: string;
    name: string;
}

@Injectable({
    providedIn: 'root'
})
export class AppdataService {
    genService = inject(GenericStreamsService);

    showHeaderBackButton = new BehaviorSubject<boolean>(false);
    headerBackButtonHref: string = "/home"
    showGreeting = new BehaviorSubject<boolean>(true);
    showMenue = new BehaviorSubject<boolean>(true);
    industryTypes: any[] = [];
    companyTypes = new BehaviorSubject<CompanyType[]>([]);
    licenseTypes: any[] = [];
    roles = new BehaviorSubject<UserRole[]>([]);
    systemLanguages: any[] = [];
    streamClosingTypes: StreamClosingType[] = [];
    intentionRoles: any[] = [];
    tagGroups: tagGroup[] = [];
    llms = new BehaviorSubject<Llm[]>([]);
    tags: any[] = [];
    steTypes: any[] = [];
    categories = new BehaviorSubject<Category[]>([]);
    customLoginForm = new BehaviorSubject<CustomLoginFormConfig[]>([]);
    tracks = new BehaviorSubject<any[]>([]);
    agents = new BehaviorSubject<AgentConfig[]>([]);
    categoryImagesThumbs = new BehaviorSubject<any[]>([]);
    statuses: any[] = [
        { "name": "ACTIVE", "id": "ACTIVE" },
        { "name": "INACTIVE", "id": "INACTIVE" },
        { "name": "DEPRECATED", "id": "DEPRECATED" },
        { "name": "DELETED", "id": "DELETED" }];

    constructor(
        private http: HttpClient,
        private snack: SnackService,
    ) {
        this.loadCompanyTypes();
        this.loadIndustryData();
        this.loadLicenseTypes();
        this.loadRoles();
        this.loadSystemLanguages();
        this.loadIntentionRoles();
        this.loadTagCategories();
        this.loadAllTags();
        this.loadCatImages();
        this.loadCloasingStreamTypes();
        this.loadAllAgents();
        this.loadAllCategories();
        // this.loadAllTracks();
        this.loadStepTypes();
        this.loadLlmData();
        this.loadCustomFormFielConfig()

        this.genService.getGenericStreams();

        let greet = localStorage.getItem('ids_greet');
        if (greet == 'false') {
            this.showGreeting.next(false);
        }
        else {
            localStorage.setItem('ids_greet', 'true');
            this.showGreeting.next(true);
        }
    }


    async loadStepTypes() {
        return await new Promise((resolve) => {
            this.http.get(serverurl + '/tracks/streams/steptypes').subscribe({
                next: async (data: any) => {
                    this.steTypes = data;
                    resolve(data);
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve([]);
                }
            });
        });
    }
    async loadSteps(): Promise<any[]> {
        return await new Promise((resolve) => {
            this.http.get(serverurl + '/tracks/streams/steps').subscribe({
                next: async (data: any) => {
                    resolve(data);
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve([]);
                }
            });
        });
    }
    async loadStreams(): Promise<any[]> {
        return await new Promise((resolve) => {
            this.http.get(serverurl + '/tracks/streams').subscribe({
                next: async (data: any) => {
                    resolve(data);
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve([]);
                }
            });
        });
    }
    async loadAllCategories() {
        return await new Promise((resolve) => {
            this.http.get(serverurl + '/category').subscribe({
                next: async (data: any) => {
                    for await (let cat of data as Category[]) {
                        if (cat.image) cat.icon = frontendserverurl + '/public/catimages/thumbs/' + cat.image;
                    }
                    this.categories.next(data);
                    // console.log('Categories loaded:', data);

                    resolve(true);
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                }
            });
        });
    }
    async loadAllTracks() {
        return await new Promise((resolve) => {
            this.http.get(serverurl + '/tracks').subscribe({
                next: async (data: any) => {
                    let streams = await this.loadStreams();
                    let steps = await this.loadSteps();
                    for await (const track of data) {
                        track.streams = streams.filter((s: any) => s.trackId == track.id);
                        for await (const stream of track.streams) {
                            stream.steps = steps.filter((s: any) => s.streamId == stream.id && s.stepTypeId.indexOf('OUTPUT_') == -1);
                        }
                    }

                    this.tracks.next(data);
                    // console.log('tracks', data);

                    resolve(true);
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                }
            });
        });
    }
    async loadAllLlmAvatars(): Promise<string[] | false> {
        return await new Promise((resolve) => {
            this.http.get(frontendserverurl + '/aiservice/avatarimages').subscribe({
                next: async (data: any) => {
                    resolve(data);
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                }
            });
        });
    }
    async loadAllAgents() {
        return await new Promise((resolve) => {
            this.http.get(frontendserverurl + '/aiservice/agents').subscribe({
                next: async (data: any) => {
                    for await (let agent of data) {
                        if (agent.avatar) agent.icon = frontendserverurl + '/public/llmavatars/' + agent.avatar;
                    }
                    this.agents.next(data);
                    resolve(true);
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                }
            });
        });
    }
    async loadAllTags() {
        return await new Promise((resolve) => {
            this.http.get(serverurl + '/tags').subscribe({
                next: async (data: any) => {
                    this.tags = data;
                    resolve(true);
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                }
            });
        });
    }
    async loadCloasingStreamTypes(): Promise<boolean> {
        return await new Promise((resolve) => {
            this.http.get(serverurl + '/tracks/genericstream-data/closing-types').subscribe({
                next: (data: any) => {
                    this.streamClosingTypes = data;
                    resolve(true);
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                }
            });
        });
    }
    async loadCustomFormFielConfig() {
        return await new Promise((resolve) => {
            this.http.get(frontendserverurl + '/public/data/custom-login-form.json').subscribe({
                next: (data: any) => {
                    this.customLoginForm.next(data as CustomLoginFormConfig[])
                    resolve(true);
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                }
            });
        });
    }
    async loadTagCategories() {
        return await new Promise((resolve) => {
            this.http.get(frontendserverurl + '/public/data/taggroups.json').subscribe({
                next: (data: any) => {
                    this.tagGroups = data;
                    resolve(true);
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                }
            });
        });
    }

    async loadCompanyTypes() {
        return await new Promise((resolve) => {
            this.http.get(frontendserverurl + '/public/data/companytypes.json').subscribe({
                next: (data: any) => {
                    this.companyTypes.next(data);
                    resolve(true);
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                }
            });
        });
    }
    async loadLlmData() {
        return await new Promise((resolve) => {
            this.http.get(frontendserverurl + '/public/data/llms.json').subscribe({
                next: (data: any) => {
                    this.llms.next(data as Llm[]);
                    resolve(true);
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                }
            });
        });
    }
    async loadIndustryData() {
        return await new Promise((resolve) => {
            this.http.get(frontendserverurl + '/public/data/industry.json').subscribe({
                next: (data: any) => {
                    this.industryTypes = data;
                    resolve(true);
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                }
            });
        });
    }
    async loadIntentionRoles() {
        return await new Promise((resolve) => {
            this.http.get(frontendserverurl + '/public/data/intentionroles.json').subscribe({
                next: (data: any) => {
                    this.intentionRoles = data;
                    resolve(true);
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                }
            });
        });
    }
    async loadLicenseTypes() {
        return await new Promise((resolve) => {
            this.http.get(frontendserverurl + '/public/data/license.json').subscribe({
                next: (data: any) => {
                    this.licenseTypes = data;
                    resolve(true);
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                }
            });
        });
    }
    async loadRoles() {
        return await new Promise((resolve) => {
            this.http.get(frontendserverurl + '/public/data/roles.json').subscribe({
                next: async (data: any) => {
                    this.roles.next(data);
                    resolve(true);
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                }
            });
        });
    }
    async loadSystemLanguages() {
        return await new Promise((resolve) => {
            this.http.get(serverurl + '/public/data/languages.json').subscribe({
                next: (data: any) => {
                    this.systemLanguages = data;
                    resolve(true);
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                }
            });
        });
    }
    async loadCatImages() {
        return await new Promise((resolve) => {
            this.http.get(frontendserverurl + '/knowledgehub/catimagesthumbs').subscribe({
                next: async (data: any) => {
                    this.categoryImagesThumbs.next(data);
                    resolve(true);
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                }
            });
        });
    }

}
